/**
 * WeAll Team Messages translation keys (admin <-> app user direct messages)
 */
const k = (suffix) => `admin.weall_team_${suffix}`;

export const weAllTeam = {
  menu: k("menu"),
  inbox_heading: k("inbox_heading"),
  new_heading: k("new_heading"),
  conversation_heading: k("conversation_heading"),
  tab_inbox: k("tab_inbox"),
  tab_new: k("tab_new"),
  inbox_search: k("inbox_search"),
  inbox_clear: k("inbox_clear"),
  col_user: k("col_user"),
  col_last_message: k("col_last_message"),
  col_last_activity: k("col_last_activity"),
  col_unread: k("col_unread"),
  col_actions: k("col_actions"),
  you_prefix: k("you_prefix"),
  action_open: k("action_open"),
  new_message_button: k("new_message_button"),
  select_user_label: k("select_user_label"),
  select_user_placeholder: k("select_user_placeholder"),
  select_user_no_options: k("select_user_no_options"),
  select_user_loading: k("select_user_loading"),
  select_user_hint: k("select_user_hint"),
  message_label: k("message_label"),
  message_placeholder: k("message_placeholder"),
  send: k("send"),
  sending: k("sending"),
  sent_info: k("sent_info"),
  back_to_inbox: k("back_to_inbox"),
  reply_placeholder: k("reply_placeholder"),
  load_older: k("load_older"),
  loading_older: k("loading_older"),
  no_messages: k("no_messages"),
  not_found: k("not_found"),
  deleted_user_notice: k("deleted_user_notice"),
  sender_team: k("sender_team"),
  status_sent: k("status_sent"),
  status_delivered: k("status_delivered"),
  status_seen: k("status_seen"),
  toast_sent: k("toast_sent"),
  toast_failed: k("toast_failed"),
  validation_user: k("validation_user"),
  validation_message: k("validation_message"),
  media_photo: k("media_photo"),
  media_video: k("media_video"),
  media_pdf: k("media_pdf"),
  media_document: k("media_document"),
  media_summary: k("media_summary"),
  media_photos: k("media_photos"),
  media_videos: k("media_videos"),
  media_documents: k("media_documents"),
  attach_file: k("attach_file"),
  remove_file: k("remove_file"),
  file_too_large: k("file_too_large"),
  validation_message_or_file: k("validation_message_or_file"),
};
